export default () => ({
    logo: {
        maxWidth: 300,
        width: "100%",
    },
    input: {
        paddingRight: 0,
    }
});